(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.MatchMediaBreakpoint = {}));
}(this, function (exports) { 'use strict';

  var getMediaQueries = function getMediaQueries(breakpoints) {
    return breakpoints.map(function (item, index) {
      return {
        breakpoint: item.breakpoint,
        query: index === 0 // eslint-disable-line no-nested-ternary
        ? "(max-width: ".concat(breakpoints[index + 1].width - 1, "px)") : index === breakpoints.length - 1 ? "(min-width: ".concat(item.width, "px)") : "(max-width: ".concat(breakpoints[index + 1].width - 1, "px) and (min-width: ").concat(item.width, "px)")
      };
    });
  };
  var getCurrentBreakpoint = function getCurrentBreakpoint(breakpoints) {
    return getMediaQueries(breakpoints).reduce(function (previous, current) {
      return window.matchMedia(current.query).matches ? current.breakpoint : previous;
    }, undefined);
  };
  function MatchMediaBreakpoint(_ref) {
    var _this = this;

    var breakpoints = _ref.breakpoints,
        onBreakpointChange = _ref.onBreakpointChange;
    this.breakpoints = getMediaQueries(breakpoints);
    this.value = getCurrentBreakpoint(breakpoints);
    this.previousValue = undefined;
    this._listeners = [];

    this._addListeners = function () {
      _this.breakpoints.map(function (item) {
        return window.matchMedia(item.query);
      }).forEach(function (item) {
        return item.addListener(_this._handleMediaQueryList);
      });
    };

    this._handleMediaQueryList = function (event) {
      if (!event.matches) return;

      _this.breakpoints.forEach(function (item) {
        if (item.query === event.media) {
          _this.previousValue = _this.value;
          _this.value = item.breakpoint;
          onBreakpointChange(item.breakpoint, _this.previousValue);

          _this._listeners.forEach(function (listener) {
            return listener(item.breakpoint, _this.previousValue);
          });
        }
      });
    };

    this._removeListeners = function () {
      _this.breakpoints.map(function (item) {
        return window.matchMedia(item.query);
      }).forEach(function (item) {
        return item.removeListener(_this._handleMediaQueryList);
      });
    };

    this.subscribe = function (listener) {
      return _this._listeners.push(listener);
    };

    this.unsubscribe = function (listener) {
      var index = _this._listeners.indexOf(listener);

      if (index === -1) return;

      _this._listeners.splice(index, 1);
    };

    this.destroy = function () {
      _this._listeners = [];

      _this._removeListeners();
    };

    this._addListeners();
  }

  exports.MatchMediaBreakpoint = MatchMediaBreakpoint;
  exports.getCurrentBreakpoint = getCurrentBreakpoint;
  exports.getMediaQueries = getMediaQueries;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
